import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  tabIndex: 0,
  nextAttendingEvent: {},
  upcomingEvents: {
    loading: true,
    collection: [],
    page: 1,
    perPage: 10,
  },
  pastEvents: {
    loading: true,
    collection: [],
    page: 1,
    perPage: 10,
  },
  upcomingOpenEvents: {
    loading: true,
    collection: [],
    page: 1,
    perPage: 10,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.EVENTS_DASHBOARD.TAB_SELECT:
      return {
        ...state,
        tabIndex: action.tabIndex,
      };
    case IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_REQUEST:
      if (action.eventsTab) {
        return {
          ...state,
          [action.eventsTab]: {
            ...state[action.eventsTab],
            loading: true,
          },
        };
      }
      return state;
    case IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_RECEIVE:
      if (action.eventsTab) {
        return {
          ...state,
          [action.eventsTab]: {
            ...action.payload[action.eventsTab],
            loading: false,
          },
        };
      }
      return {
        ...state,
        upcomingEvents: {
          ...action.payload.upcomingEvents,
          loading: false,
        },
        pastEvents: {
          ...action.payload.pastEvents,
          loading: false,
        },
        upcomingOpenEvents: {
          ...action.payload.upcomingOpenEvents,
          loading: false,
        },
        nextAttendingEvent: {
          ...action.payload.nextAttendingEvent,
        },
      };
    case IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_FAILURE:
      // Tab error handling
      return false;
    default:
      return state;
  }
};
